/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../../../../presentation/contexts/loading'

import { useMe } from '../../../../../presentation/contexts/me'
import { useModal } from '../../../../../presentation/contexts/modal'
import { useOrder } from '../../../../../presentation/contexts/order'
import { usePage } from '../../../../../presentation/contexts/page'
import Orders from '../../../../../presentation/pages/dashboard/orders'
import { makeEvent } from '../../../../usecases/events/load-event-factory'
import { makeTableOrder } from '../../../../usecases/table-orders/load-table-orders'
import { getOrderPadStatusToPay, getOrderStatus } from '../../../../../presentation/helpers/helper-order-status'

const searchOptionsFilters = ['Todos', 'Em aberto', 'Aguardando pagamento', 'Mesa vazia']

const MakeOrders = () => {
  const { me } = useMe()
  const { toggleVisibility } = useModal()
  const { setHeader } = usePage()
  const { onSetLoading } = useLoading()
  const {
    order: orderSelected,
    setOrder: setOrderSelected,
    lastEvent: doesOrderListUpdated,
  } = useOrder()
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null)
  const [orders, setOrders] = useState<any>([])
  const [currentPageId, setCurrentPageId] = useState(0)
  const [search, setSearch] = useState('')
  const [filteredOrder, setFilteredOrder] = useState([])
  const [count, setCount] = useState(0)
  const [lastEvent, setLastEvent] = useState<any>(null)

  const intervalInSeconds = 1000 * 30

  const loadEvent = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const lastEventByApi = (await makeEvent(stablishmentId).load()).events
        .filter((event: any) => (
          event.type === 1
        ))[0]

      if (lastEventByApi?.id !== lastEvent?.id) {
        setLastEvent(lastEventByApi)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const filterBySelect = (order: any) => {
    if (selectedFilter === null && (order.status !== 2)) return true

    if (selectedFilter === String(order.status ?? 2)) {
      return true
    }

    return false
  }

  const filterBySearch = (order: any) => {
    const searchWithoutHashtag = search.replace('#', '')
    if (searchWithoutHashtag === '') return true

    if (
      String(order.name).toLowerCase() === searchWithoutHashtag.toLowerCase()
      || String(order.code).toLowerCase() === searchWithoutHashtag.toLowerCase()
    ) {
      return true
    }

    return String(order.name ?? '').includes(searchWithoutHashtag)
      || String(order.code ?? '').includes(searchWithoutHashtag)
  }

  useEffect(() => {
    const filteredOrders = orders
      .filter(filterBySelect)
      .filter(filterBySearch)
      .reduce((acc: any, order: any) => {
        if (order.status === 9) return acc
        const status = getOrderPadStatusToPay(order.status)
        const ordersWithSameTable = acc.filter((o: any) => o.tableId === order.tableId)

        // Verifica se existem pedidos com needPayment 0 e 1 para a mesma mesa
        const hasNeedPaymentZero = ordersWithSameTable.some((o: any) => o.needPayment === 0)
        const hasNeedPaymentOne = ordersWithSameTable.some((o: any) => o.needPayment === 1)
        const hasConflictingPaymentStatus = hasNeedPaymentZero && hasNeedPaymentOne

        const current = {
          ...order,
          needPayment: status,
          status: getOrderStatus(order.status),
          isUniqueOrderWrapper: !hasConflictingPaymentStatus,
        }

        // Atualiza isUniqueOrderWrapper para todos os pedidos da mesma mesa
        const updatedAcc = acc.map((o: any) => (o.tableId === order.tableId
          ? { ...o, isUniqueOrderWrapper: !hasConflictingPaymentStatus }
          : o))

        // Verifica se já existe um pedido com o mesmo needPayment
        const existingSamePaymentStatus = ordersWithSameTable
          .some((o: any) => o.needPayment === status)

        return existingSamePaymentStatus ? updatedAcc : [...updatedAcc, current]
      }, [])
    setFilteredOrder(filteredOrders)
  }, [search, selectedFilter, orders, lastEvent])

  const navbarItems = [
    { label: 'Pedidos', onClick: () => setCurrentPageId(0) },
    { label: 'Dados gerais do pedido', onClick: () => setCurrentPageId(1) },
  ]

  const handlePaidTheBill = () => {
    toggleVisibility()
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: '',
        goTo: null,
      })
      onSetLoading(true)
      try {
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeTableOrder(stablishmentId).loadStatus()
        setOrders(response.orders)

        if (!orderSelected) return
        const updateCurrentOrder = response.orders.find((fr: any) => fr.id === orderSelected.id)
        setOrderSelected(updateCurrentOrder)
      } catch (error) {
        console.log(error)
      } finally {
        onSetLoading(false)
      }
    })()
  }, [setHeader, me, lastEvent])

  useEffect(() => {
    const timer = setTimeout(() => {
      loadEvent()
      setCount((state) => state + 1)
    }, intervalInSeconds)
    return (() => {
      clearInterval(timer)
    })
  }, [count, lastEvent])

  useEffect(() => {
    loadEvent()
  }, [doesOrderListUpdated])

  return (
    <Orders
      search={search}
      setSearch={setSearch}
      selectedFilter={selectedFilter}
      setSelectedFilter={setSelectedFilter}
      searchOptions={{ filters: searchOptionsFilters }}
      orders={filteredOrder}
      navbarItems={navbarItems}
      currentPageId={currentPageId}
      handlePaidTheBill={handlePaidTheBill}
    />
  )
}

export default MakeOrders
